import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { BillingReportDataProps, IssueProductListReducer, PurchaseProductList, SalesProductListReducer, SingleMemberBillProps } from '../helpers/models/Models';

interface InventoryState {
    PurchaseProductList: PurchaseProductList[];
    IssueProductList: IssueProductListReducer[];
    SalesProductList: SalesProductListReducer[];
    BillingList: BillingReportDataProps;
}

const initialState: InventoryState = {
    PurchaseProductList: [],
    IssueProductList: [],
    SalesProductList: [],
    BillingList: {
        receipt_list: [],
        member_details: {
            member_sn: 0,
            mem_name: "",
            mem_name_nep: "",
            add_nep: "",
            ward_no: 0,
            add_eng: null,
            sms_mob_no: null,
            tole_name: null,
            tole_name_nep: null,
        },
        date_ne: '',
        receipt_no: 0
    },
};

const inventorySlice = createSlice({
    name: 'inventory',
    initialState,
    reducers: {
        PURCHASE_PRODUCT_LIST: (state, action: PayloadAction<PurchaseProductList[]>) => {
            state.PurchaseProductList = [
                ...state.PurchaseProductList,
                ...action.payload
            ];
        },
        PURCHASE_DELETE_PRODUCT_ITEM: (state, action: PayloadAction<number>) => {
            state.PurchaseProductList = state.PurchaseProductList.filter(
                item => item.product !== action.payload
            );
        },
        PURCHASE_CLEAR_PRODUCT_ITEM: (state) => {
            state.PurchaseProductList = [];
        },

        ISSUE_PRODUCT_LIST: (state, action: PayloadAction<IssueProductListReducer[]>) => {
            state.IssueProductList = [
                ...state.IssueProductList,
                ...action.payload
            ];
        },
        ISSUE_DELETE_PRODUCT_ITEM: (state, action: PayloadAction<number>) => {
            state.IssueProductList = state.IssueProductList.filter(
                item => item.product !== action.payload
            );
        },
        ISSUE_CLEAR_PRODUCT_ITEM: (state) => {
            state.IssueProductList = [];
        },

        SALES_PRODUCT_LIST: (state, action: PayloadAction<SalesProductListReducer[]>) => {
            state.SalesProductList = [
                ...state.SalesProductList,
                ...action.payload
            ];
        },
        SALES_DELETE_PRODUCT_ITEM: (state, action: PayloadAction<number>) => {
            state.SalesProductList = state.SalesProductList.filter(
                item => item.product !== action.payload
            );
        },
        SALES_CLEAR_PRODUCT_ITEM: (state) => {
            state.SalesProductList = [];
        },

        BILLING_REPORT_LIST_VIEW: (state, action: PayloadAction<BillingReportDataProps>) => {
            state.BillingList = action.payload;
        },
    }
});

export const {
    PURCHASE_PRODUCT_LIST,
    PURCHASE_DELETE_PRODUCT_ITEM,
    PURCHASE_CLEAR_PRODUCT_ITEM,
    ISSUE_PRODUCT_LIST,
    ISSUE_DELETE_PRODUCT_ITEM,
    ISSUE_CLEAR_PRODUCT_ITEM,
    SALES_PRODUCT_LIST,
    SALES_DELETE_PRODUCT_ITEM,
    SALES_CLEAR_PRODUCT_ITEM,
    BILLING_REPORT_LIST_VIEW,
} = inventorySlice.actions;

export default inventorySlice.reducer;
